import { Link, useNavigate } from 'react-router-dom';
import img1 from '../assets/images/pattern.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useAuth } from '../Redux/hooks/useAuth';
import { useDispatch } from 'react-redux';
import { ResetRequest, useGetCaptchaQuery, useResetSendCodeMutation, useResetVerifyMutation } from '../Redux/Apis/authApi';
import { setCredentials } from '../Redux/Slices/authSlice';
import MetaTags from '../Components/MetaTags';

function Reset() {
    const navigate = useNavigate()
    const auth = useAuth()
    useEffect(() => {
        if (auth.user) navigate('/panel')
    })

    const dispatch = useDispatch()
    
    const [verify, { isLoading : isVerifyLoading }] = useResetVerifyMutation()
    const [send_code, {isLoading : isCodeLoading}] = useResetSendCodeMutation()
    const [refresh, setRefresh ] = useState(1)
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [type, setType] = useState("first")

    const { data } = useGetCaptchaQuery({refresh})
    const getCaptcha = () =>  {
        setRefresh((prev) => prev + 1)
    }

    const [formState, setFormState] = useState<ResetRequest>({
        email: '',
        password: '',
        captcha: '',
        code: '',
    })

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(type === "first"){
                delete formState.code
                await send_code(formState).unwrap()
                setType("otp")
                setErrorMsg(false) 
            }else{
                const user = await verify(formState).unwrap()
                dispatch(setCredentials(user))
                navigate('/')
            }
            
        } catch (err:any){
            // console.log(err);
            getCaptcha();
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }


    return ( 
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title="بازنشانی رمز عبور | سایت مرجع آزمون GRE"
            description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
            url="https://grehub.org/login"
            image="https://grehub.org/GREhub_LOGO.jpg"
            ogType="website"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid position-relative p-0">
            <div className="row pt-lg-5 g-0">
                <div className="col-lg-6 object-fit-fill">
                    <img src={img1} className="img-fluid h-100" style={{objectFit: "cover"}} alt="login"/>
                </div>
                <div className="col-lg-6 p-5 mt-lg-5">
                    <div className='p-5'>
                        <h2 className='text-danger'><Link to="/login" className='btn btn-outline-secondary me-2' aria-label='back'><FontAwesomeIcon icon="chevron-right" className='align-middle'/></Link>بازنشانی رمز عبور</h2>
                        <p>جهت تغییر رمز عبور ایمیل کاربری خود را وارد نمایید:</p>
                        {errorMsg && <div className="alert alert-warning" role="alert">
                            {errorMsg}
                        </div>}
                        <form id="login-form" onSubmit={onSubmit}>
                            <div className="row g-3">
                                <div className="col-12 mb-3">
                                    <label htmlFor="email" className="form-label">ایمیل</label>
                                    <input type="email" disabled={type === "otp"} value={formState.email} onChange={handleChange} name="email" id='email' className="form-control border-0 bg-light px-4" placeholder="آدرس ایمیل خود را وارد نمایید" style={{height: "55px",direction: "rtl"}}/>
                                </div>

                                {type === "otp" && 
                                <><div className="col-12 mb-3">
                                    <label htmlFor="code" className="form-label">کد ایمیل شده</label>
                                    <input type="text" value={formState.code} onChange={handleChange} name="code" id='code' aria-describedby='sended-code' className="form-control border-0 bg-light px-4" placeholder="کد ارسالی را وارد نمایید" maxLength={6} style={{height: "55px"}}/>
                                    <div className="form-text text-secondary" id="sended-code"><FontAwesomeIcon className='align-middle me-1' icon="exclamation-circle"/>حتما داخل پوشه اسپم خود را نیز بررسی نمایید.</div>
                                </div>
                                <div className="col-12 mb-3">
                                    <label htmlFor="password" className="form-label">رمز عبور جدید</label>
                                    <input type="password" value={formState.password} onChange={handleChange} name="password" id='password' className="form-control border-0 bg-light px-4" placeholder="رمز عبور جدید خود را وارد نمایید" aria-describedby="reset" style={{height: "55px"}}/>
                                </div></>}

                                {type !== "otp" && 
                                <div className="col-12 input-group mb-3">
                                    <input type="text" name="captcha" value={formState.captcha} id='your_captcha' aria-label="user captcha" aria-describedby="captcha" onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="کد داخل تصویر" maxLength={4} style={{height: "55px"}}/>
                                    <span className="input-group-text border-0" id="captcha" style={{height: "55px"}}>
                                        <div onClick={getCaptcha} className="text-center" dangerouslySetInnerHTML={{ __html: data?.data! }}></div>
                                    </span>
                                </div>}
                                
                                <div className="col-12">
                                    <input disabled={isCodeLoading || isVerifyLoading} name="signin" id="signin" className="btn btn-danger w-100 py-3" type="submit" value={type === "first" ? "ادامه" : "بازنشانی رمز عبور"}/>
                                </div>
                            </div>
                        </form>
                        <p className='text-center mt-5 py-1'>
                        <FontAwesomeIcon icon="user-plus" className='me-1'/>
                        حساب کاربری ندارید؟  
                        &nbsp;
                        <Link to="/signup" className='text-decoration-underline'>ازینجا ثبت نام کنید</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </>
     );
}

export default Reset;